import { PAGE_URL, PERMISSION_KEY } from "../services/constant";

const apiKeyPermissionGroupMappingMenuRegistry = {
    core_apiKeyPermissionGroupMapping: {
        label: "API Key Permission Group Mapping",
        link: PAGE_URL.API_KEY_PERMISSION_GROUP_MAPPING_PAGE,
        key: PAGE_URL.API_KEY_PERMISSION_GROUP_MAPPING_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default apiKeyPermissionGroupMappingMenuRegistry;
